import React from 'react';

import colors from 'utils/colors';

import CircleTick from '../Icons/CircleTick';
import ThumbDown from '../Icons/ThumbDown';
import ThumbUp from '../Icons/ThumbUp';
import Text from '../Text';
import { CircleTickWrapper, ThumbWrapper } from './styled';

export type ComponentProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  /**
   * The thumb type to be rendered
   */
  type: 'up' | 'down';
  /**
   * The disabled status of the item
   */
  disabled: boolean;
  /**
   * The selected status of the item
   */
  selected: boolean;
  /**
   * The label to render with the item
   */
  feedbackText: string;
};

const FeedbackItem: React.FC<ComponentProps> = ({
  type = 'up',
  onClick,
  disabled = false,
  selected = false,
  feedbackText,
  ...props
}) => {
  return (
    <ThumbWrapper
      type='button'
      onClick={onClick}
      disabledStyle={disabled}
      selected={selected}
      {...props}>
      {selected && (
        <CircleTickWrapper>
          <CircleTick fill={colors.orange} />
        </CircleTickWrapper>
      )}
      {type === 'up' ? (
        <ThumbUp selected={selected} disabled={disabled} />
      ) : (
        <ThumbDown selected={selected} disabled={disabled} />
      )}
      <Text.Body fontWeight={500} as='span'>
        {feedbackText}
      </Text.Body>
    </ThumbWrapper>
  );
};

export default FeedbackItem;
